import type { Tournament } from '@/types/tournament.model';

export enum TournamentSortOption {
  START_DATE_ASC = 'START_DATE_ASC',
  START_DATE_DESC = 'START_DATE_DESC',
  NAME_ASC = 'NAME_ASC',
  NAME_DESC = 'NAME_DESC',
  SIGNUP_DEADLINE_ASC = 'SIGNUP_DEADLINE_ASC',
}

export const getSortLabel = (option: TournamentSortOption): string => {
  switch (option) {
    case TournamentSortOption.START_DATE_ASC:
      return 'Fecha de inicio (Más cercano)';
    case TournamentSortOption.START_DATE_DESC:
      return 'Fecha de inicio (Más lejano)';
    case TournamentSortOption.NAME_ASC:
      return 'Nombre (A-Z)';
    case TournamentSortOption.NAME_DESC:
      return 'Nombre (Z-A)';
    case TournamentSortOption.SIGNUP_DEADLINE_ASC:
      return 'Fecha límite inscripción (Más cercana)';
    default:
      return 'Ordenar por';
  }
};

export const sortTournaments = (
  tournaments: Tournament[],
  sortOption: TournamentSortOption,
): Tournament[] => {
  const sorted = [...tournaments];

  switch (sortOption) {
    case TournamentSortOption.START_DATE_ASC:
      return sorted.sort(
        (a, b) =>
          new Date(a.startDate).getTime() - new Date(b.startDate).getTime(),
      );

    case TournamentSortOption.START_DATE_DESC:
      return sorted.sort(
        (a, b) =>
          new Date(b.startDate).getTime() - new Date(a.startDate).getTime(),
      );

    case TournamentSortOption.NAME_ASC:
      return sorted.sort((a, b) => a.name.localeCompare(b.name));

    case TournamentSortOption.NAME_DESC:
      return sorted.sort((a, b) => b.name.localeCompare(a.name));

    case TournamentSortOption.SIGNUP_DEADLINE_ASC:
      return sorted.sort(
        (a, b) =>
          new Date(a.signupDeadlineDate).getTime() -
          new Date(b.signupDeadlineDate).getTime(),
      );

    default:
      return sorted;
  }
};


